import Button from 'antd/lib/button';
import Radio from 'antd/lib/radio';
import Icon from 'antd/lib/icon';
import Form, { FormComponentProps } from 'antd/lib/form';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import Input from 'antd/lib/input';
import Modal from 'antd/lib/modal';
import Divider from 'antd/lib/divider';
import Upload from 'antd/lib/upload';
import { getFileExtension } from 'src/utils/utils';
import * as React from 'react';
import InjectSheet from 'react-jss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createAddress, fetchUsersV3, updateAddress } from 'src/api/organisationProfiling';
import { KeyValue } from 'src/dto/Types';
import { LabelValue , StylesProps } from 'src/Library/Types';
import { fileUploadOnS3 } from 'src/api/inquiry';
import { uploadImageToS3 } from 'src/api/salesorder';
import { Address, File } from 'src/components/common/Types/CommonTypes';
import { inchargeOptions, locationTypes } from '../consignorAddressConstants';
import { useGenericState } from 'src/Library/UseGenericState';
import { renderInputField } from 'src/Library/Common';
import AddEditAddressForm from '../../Triangulation/AddEditAddressForm';
import isEmpty from 'lodash/isEmpty';
import { getFormattedAddress } from '../../Triangulation/ContainerTriangulation.utils';
import FieldMultiSelectPOL from '../../RFQ/common/FieldMultiSelectPOL';
import ApiDto from 'src/dto/ApiDto';
import { locationPreferences } from '../OrganisationUtils';
import { tokens } from 'src/design-system';
const styles = (theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    fontSize: '16px',
    margin: '16px 3%',
  },
  mainDiv: {
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  rowDiv: {
    display: 'flex',
    alignItems: 'center',
    padding: 6,
    '& .ant-form-item': {
      margin: 0,
      padding: 0,
    },
    '& .ant-form-explain': {
      fontSize: 10,
    },
    '& .ant-radio-wrapper': {
      fontSize: '12px',
    },
  },
  title: {
    paddingTop: '5px',
    color: '#262626',
    fontSize: '12px',
    fontWeight: 600,
  },
  newUserDiv: {
    display: 'flex',
    flexDirection: 'column',
    // marginLeft: 12,
    paddingLeft: 6,
  },
  userRow: {
    marginBottom: 10,
    fontSize: 12,
  },
  submitButton: {
    backgroundColor: '#1890FF',
    border: '#1890FF',
    borderRadius: '4px',
  },
  buttons: {
    display: 'flex',
    marginTop: '16px',
    width: '97%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  editConsignorModal: {
    '& .ant-modal-title': {
      fontSize: '16px',
      color: '#444444',
      fontWeight: 'bold',
    },
  },
});

const { useState, useEffect } = React;

interface EditConsignorProps extends StylesProps<ReturnType<typeof styles>>, FormComponentProps {
  data: Address;
  orgMaster;
  closeEdit: () => void;
  refreshAddresses: () => void;
  isModal: boolean;
  visible: boolean;
  consignorAddressTypes;
  incoterms: any[];
}

interface User {
  id: string;
  name: string;
}

interface Doc {
  uploading: boolean;
  file: File;
}
interface StateProps {
  users: User[];
  updating: boolean;
  docs: Doc;
  addressObject?;
}

const EditConsignorOrgModal = (props: EditConsignorProps) => {
  const {
    data,
    classes,
    orgMaster,
    closeEdit,
    form,
    isModal,
    visible,
    consignorAddressTypes,
    incoterms,
    refreshAddresses,
  } = props;

  const { getFieldValue, getFieldDecorator, validateFields, setFieldsValue } = form;

  const [state, setState] = useGenericState<StateProps>({
    users: [],
    updating: false,
    docs: {
      uploading: false,
      file: {} as File,
    },
    addressObject: !isEmpty(data)
      ? {
          ...data,
          latLng: {
            lat: data?.latitude,
            lng: data?.longitude,
          },
          mapLocation: {
            latLng: {
              lat: data?.latitude,
              lng: data?.longitude,
            },
          },
          formattedAddress: getFormattedAddress(data),
        }
      : {
        location: 'FACTORY'
      },
  });

  const { users, updating, docs, addressObject } = state;

  useEffect(() => {
    if (data.stuffingPermissionDocument) {
      setState({
        docs: { ...docs, file: data.stuffingPermissionDocument },
      });
    }
    setFieldsValue({
      ...data,
      id: undefined,
      incharge: data.inchargeUserId ? 'existing' : 'other',
    });
    fetchUserList();
  }, []);

  const isEdit = !!(data && Object.keys(data).length);

  const fetchUserList = async (): Promise<void> => {
    const response = await fetchUsersV3();
    setState({
      users: response.isSuccess ? response.data : [],
    });
    if (response.error) {
      message.error(response.errorMessage);
    }
  };

  const handleSubmit = async (): Promise<void> => {
    validateFields(async (err, values) => {
      if (err) return;
      // if (!addressObject?.mapLocation?.latLng?.lng || !addressObject?.mapLocation?.latLng?.lat) {
        // message.error('Please select location on google map');
        // return;
      // }
      await handleUpdate(values);
    });
  };

  const handleUpdate = async (
    values: typeof ApiDto.CreateConsignorAddressDto | typeof ApiDto.UpdateConsignorAddressDto
  ) => {
    setState({
      updating: true,
    });
    const { id } = data;
    const apiObject = values;
    apiObject.location = addressObject.location || 'FACTORY';
    apiObject.stuffingPermissionDocument = docs.file;
    if (docs.file.url) {
      apiObject.stuffingPermissionDocument = {
        url: docs.file.url,
        name: docs.file.name,
      };
    } else {
      apiObject.stuffingPermissionDocument = undefined;
    }
    if (getFieldValue('incharge') === 'existing') {
      apiObject.inchargeContactEmail = '';
      apiObject.inchargeContactName = '';
      apiObject.inchargeContactPhone = '';
    } else {
      apiObject.inchargeUserId = undefined;
    }
    apiObject.countryId =
      values?.countryId === addressObject?.mapLocation?.country
        ? undefined
        : values?.countryId; /* country name will be sent if the country is prefilled from the map
      since we will not get the country id from googlemap */
    apiObject.countryName =
      values?.countryId === addressObject?.mapLocation?.country || !values?.countryId
        ? addressObject?.mapLocation?.country
        : undefined;
    apiObject.longitude = addressObject?.mapLocation?.latLng?.lng;
    apiObject.latitude = addressObject?.mapLocation?.latLng?.lat;
    const originPort = apiObject?.originPortId as { key: string; label: string } | undefined;
    const destinationPort = apiObject?.destinationPortId as
      | { key: string; label: string }
      | undefined;
    apiObject.originPortId = originPort?.key;
    apiObject.destinationPortId = destinationPort?.key;
    if (addressObject.location === 'CFS') {
      apiObject.addressTypes = ['STUFFING', 'DESTUFFING'];
      apiObject.locationType = 'WAREHOUSE';
    }
    const response = id ? await updateAddress(id, apiObject) : await createAddress(apiObject);
    if (response.isSuccess) {
      message.success(`Address ${data.id ? 'updated' : 'created'} successfully`);
      refreshAddresses();
    } else {
      message.error(response.errorMessage);
    }
    setState({
      updating: false,
    });
  };

  const s3LinkRequest = async ({ file }) => {
    setState({
      docs: {
        ...docs,
        uploading: true,
      },
    });
    const extension = getFileExtension(file.name);
    const response = await fileUploadOnS3({
      extension,
      fileName: file.name,
      document_type: file.type,
    });
    if (response.isSuccess) {
      const upload = await uploadImageToS3(file, response.data.post, extension);
      if (upload.isSuccess) {
        setState({
          docs: {
            ...docs,
            file: {
              name: file.name,
              url: response.data.get,
            },
            uploading: false,
          },
        });
      }
    } else {
      message.error(response.errorMessage);
      setState({
        docs: {
          ...docs,
          file: {
            name: file.name,
            url: response.data.get,
          },
          uploading: false,
        },
      });
    }
  };

  const renderLocationField = (): React.ReactElement => {
    return (
      <Row gutter={24} className={classes.rowDiv}>
        <Col span={4} className={classes.title}>
          Location Type
        </Col>
        <Col span={10}>
          <Form.Item>
            {getFieldDecorator('locationType', {
              rules: [{ required: true, message: 'Please select location type' }],
            })(
              <Radio.Group style={{ fontSize: '12px' }} options={locationTypes} disabled={isEdit} />
            )}
          </Form.Item>
        </Col>
        <Col span={10}>
          <Row>
            <Col span={12} className={classes.title}>
              Stuffing Permission Document
            </Col>
            <Col span={12}>
              <Upload
                style={{ width: '25%' }}
                showUploadList={false}
                multiple={false}
                customRequest={(file: any) => s3LinkRequest(file)}
              >
                <Button style={{ marginLeft: '10px' }}>
                  <Icon type="upload" /> Upload
                </Button>
              </Upload>
            </Col>
          </Row>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignContent: 'center',
              width: '80%',
              marginLeft: '2%',
            }}
          >
            {docs.uploading && (
              <div style={{ width: '5%' }}>
                <Spin
                  indicator={
                    <Icon
                      type="loading"
                      style={{
                        fontSize: 20,
                        marginTop: '5px',
                      }}
                      spin
                    />
                  }
                />
              </div>
            )}
            {docs?.file?.url ? (
              <div
                style={{
                  width: '100%',
                  paddingTop: '3px',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <a href={docs.file.url} style={{ marginRight: '5%' }}>
                  {docs.file.name}
                </a>
                <Icon
                  type="close"
                  style={{
                    color: tokens.colors.error,
                    cursor: 'pointer',
                    marginLeft: '1%',
                    marginTop: '7px',
                  }}
                  onClick={() => {
                    const newDocs = {
                      ...docs,
                      file: {} as File,
                    };
                    setState({ docs: newDocs });
                  }}
                />
              </div>
            ) : (
              ''
            )}
          </div>
        </Col>
      </Row>
    );
  };

  const renderLocationInput = () => {
    return (
        <Row gutter={12} className={classes.rowDiv}>
          <Col span={4} className={classes.title}>
            Location*
          </Col>
          <Col style={{ paddingLeft: '10px', paddingRight: '2px', ...styles }}>
            <Form.Item>
              {getFieldDecorator('location', {
                initialValue: addressObject?.location || locationPreferences.FACTORY,
                rules: [
                  {
                    required: true,
                    message: 'Required',
                  },
                ],
              })(
                <Select
                  style={{ width: '100%' }}
                  placeholder="Select Location"
                  disabled={isEdit}
                  onChange={(value) => {
                    setState({ addressObject: {
                      ...addressObject,
                      location: value
                      } 
                    })
                  }}
                >
                  {Object.keys(locationPreferences)?.map((item) => (
                    <Select.Option key={item}>{locationPreferences[item]}</Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
    )
  }

  const renderCountryField = (): React.ReactElement => {
    return (
      <Col span={5}>
        <Form.Item>
          {getFieldDecorator('countryId', {
            rules: [{ required: true, message: 'Required' }],
          })(
            <Select
              style={{ width: '100%' }}
              showSearch
              filterOption={(val, option: any) => {
                const optionval = option.props.children
                  ? option.props.children.trim().toLowerCase()
                  : '';
                return !val || optionval.includes(val.trim().toLowerCase());
              }}
              placeholder="Select country"
            >
              {orgMaster?.countriesList?.map((item) => (
                <Select.Option key={item.id} {...item}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Col>
    );
  };

  const renderAddresstypeField = (): React.ReactElement => {
    return (
      <Col span={8} style={{ paddingLeft: '12px' }}>
        <Form.Item>
          {getFieldDecorator('addressTypes', {
            rules: [
              {
                required: true,
                message: 'Required',
              },
            ],
          })(
            <Select
              disabled={data?.addressTypes?.length > 0}
              mode="multiple"
              showSearch
              style={{ width: '100%' }}
              placeholder="Address type"
            >
              {consignorAddressTypes?.map((item) => (
                <Select.Option key={item.key}>{item.label}</Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Col>
    );
  };

  const renderInchargeType = (): React.ReactElement => {
    return (
      <Col span={8} style={{ paddingLeft: '16px' }}>
        <Form.Item>
          {getFieldDecorator('incharge', {})(<Radio.Group options={inchargeOptions} />)}
        </Form.Item>
      </Col>
    );
  };

  const renderInchargeField = () => {
    const incharge = getFieldValue('incharge');
    return (
      <>
        {renderNewUser(incharge === 'existing' ? 'none' : 'block')}
        <Row
          gutter={12}
          className={classes.rowDiv}
          style={{ display: incharge !== 'existing' ? 'none' : 'block' }}
        >
          <Col span={4} />
          <Col span={8} style={{ paddingLeft: '12px' }}>
            <Form.Item>
              {getFieldDecorator(
                'inchargeUserId',
                {}
              )(
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Select User"
                >
                  {users &&
                    users.map((user) => <Select.Option key={user.id}>{user.name}</Select.Option>)}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  };

  const renderAddressTypes = (): React.ReactElement => {
    return (
      <Row gutter={12} className={classes.rowDiv}>
        <Col span={4} className={classes.title}>
          Address Type*
        </Col>
        {renderAddresstypeField()}
      </Row>
    );
  };

  const renderName = (): React.ReactElement => {
    return (
      <Row gutter={12} className={classes.rowDiv}>
        <Col span={4} className={classes.title}>
          Name*
        </Col>
        {renderInputField(form, 'name', 'Organisation Name', true)}
      </Row>
    );
  };

  const renderAddressLandmark = (): React.ReactElement => {
    return (
      <Row gutter={12} className={classes.rowDiv}>
        <Col span={4} className={classes.title}>
          Address Details*
        </Col>
        {renderInputField(form, 'address', 'Address', true)}
        {renderInputField(form, 'landmark', 'Landmark', false, 10, 0)}
      </Row>
    );
  };

  const renderCityState = (): React.ReactElement => {
    return (
      <Row gutter={12} className={classes.rowDiv}>
        <Col span={4} className={classes.title}></Col>
        {renderInputField(form, 'pincode', 'PIN Code', false, 4, 12)}
        {renderInputField(form, 'city', 'City', false, 6, 0)}
        {renderInputField(form, 'state', 'State', false, 5, 0)}
        {renderCountryField()}
      </Row>
    );
  };

  const renderIncharge = (): React.ReactElement => {
    return (
      <React.Fragment>
        <Row gutter={12} className={classes.rowDiv}>
          <Col span={4} className={classes.title}>
            Incharge Contact Details
          </Col>
          {renderInchargeType()}
        </Row>
        {renderInchargeField()}
      </React.Fragment>
    );
  };

  const renderDivider = () => {
    return <Divider style={{ margin: '15px 0px' }} />;
  };

  const setLocationFields = (props): void => {
    setState({
      addressObject: {
        ...addressObject,
        ...props?.addressObject,
      },
    });
  };

  const renderMapLocation = () => {
    return (
      <div style={{ margin: '10px 0 20px 6px' }}>
        {/* <AddEditAddressForm
          isConsignerAddressModal={true}
          form={form}
          setLocationFields={setLocationFields}
          prefillingAddress={addressObject}
        /> */}
      </div>
    );
  };

  const renderFinalOriginDestinationPort = ({
    required = false,
    isDisabled = false,
    isFinalPol,
  }: {
    required?: boolean;
    isDisabled?: boolean;
    isFinalPol: boolean;
  }) => {
    const formLayout = {
      wrapperCol: { span: 8 },
    };

    const params = isFinalPol
      ? {
          label: 'Final POL',
          inputKey: 'originPortId',
          initialValue: undefined,
        }
      : {
          label: 'Final POD',
          inputKey: 'destinationPortId',
          initialValue: undefined,
        };

    const { label, inputKey, initialValue } = params;
    const initialValues = isFinalPol ? data?.originPortId : data?.destinationPortId;

    return (
      <Row gutter={12} className={classes.rowDiv}>
        <Col span={4} className={classes.title} style={{ marginTop: '6px' }}>
          {label}
        </Col>
        <Col span={12}>
          <Form.Item style={{ marginBottom: 0 }}>
            {form.getFieldDecorator(inputKey, {
              initialValue,
              rules: [{ required, message: 'Cannot be empty!' }],
            })(
              <FieldMultiSelectPOL
                isWet={true}
                isAir={true}
                isDry={true}
                allowedPortTypes={['DRY', 'WET', 'AIR']}
                placeholder={label}
                singleMode={true}
                initialValueIds={[initialValues]}
                disabled={isDisabled}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderIncoterms = () => {
    return (
      <Row gutter={12} className={classes.rowDiv}>
        <Col span={4} className={classes.title}>
          Incoterm
        </Col>
        <Col span={8}>
          <Form.Item>
            {getFieldDecorator('incoterm', {
              rules: [
                {
                  required: false,
                  message: 'Required',
                },
              ],
            })(
              <Select showSearch style={{ width: '100%' }} placeholder="Select Incoterm">
                {incoterms?.map((item) => (
                  <Select.Option key={item}>{item}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderForm = (): React.ReactElement => {
    const { addressObject: { location } } = state;
    return (
      <Form style={{ margin: isModal ? 0 : '0 1.5%' }} className={classes.mainDiv}>
        {renderLocationInput()}
        {addressObject.location === 'FACTORY' && renderLocationField()}
        {addressObject.location === 'FACTORY' && renderMapLocation()}
        {addressObject.location === 'FACTORY' && renderAddressTypes()}
        {renderName()}
        {renderAddressLandmark()}
        {renderCityState()}
        {addressObject.location === 'FACTORY' && renderDivider()}
        {addressObject.location === 'FACTORY' && renderIncharge()}
        {addressObject.location === 'FACTORY' && renderDivider()}
        {addressObject.location === 'FACTORY' && renderFinalOriginDestinationPort({ isFinalPol: true })}
        {addressObject.location === 'FACTORY' && renderFinalOriginDestinationPort({ isFinalPol: false })}
        {addressObject.location === 'FACTORY' && renderIncoterms()}
      </Form>
    );
  };

  const renderNewUser = (display: 'none' | 'block'): React.ReactElement => {
    return (
      <Row style={{ display }} className={classes.rowDiv} gutter={12}>
        <Col span={4} />
        <Col span={20} className={classes.newUserDiv}>
          <Row className={classes.userRow}>
            {renderInputField(form, 'inchargeContactName', 'Name', false, 8)}
          </Row>
          <Row className={classes.userRow}>
            {renderInputField(form, 'inchargeContactEmail', 'Email', false, 12)}
            {renderInputField(form, 'inchargeContactPhone', 'Phone', false, 8, 6)}
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Modal
      className={classes.editConsignorModal}
      width={800}
      title={isEdit ? 'Edit Location Details' : 'Add Location Details'}
      visible={visible}
      style={{ padding: '0' }}
      onCancel={closeEdit}
      footer={[
        <Button onClick={closeEdit} style={{ marginRight: '15px', backgroundColor: '#F2F4F6' }}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          style={{
            background: '#1890FF',
            border: '#1890FF',
            color: '#FFFFFF',
          }}
          onClick={handleSubmit}
          loading={updating}
        >
          {data.id ? 'Update' : 'Add'}
        </Button>,
      ]}
    >
      {renderForm()}
    </Modal>
  );
};

const getMasterIncoterms = (incoterms) => {
  let incotermsMap = {};
  for (const modeKey in incoterms) {
    if (Object.prototype.hasOwnProperty.call(incoterms, modeKey)) {
      const rfqTypes = incoterms[modeKey];
      for (const type in rfqTypes) {
        if (Object.prototype.hasOwnProperty.call(rfqTypes, type)) {
          const element = rfqTypes[type];
          incotermsMap = { ...incotermsMap, ...element };
        }
      }
    }
  }
  return Object.keys(incotermsMap || {});
};

const mapStateToProps = ({ organisation, masterData }, ownProps) => ({
  orgMaster: organisation.orgMaster,
  profileData: organisation.orgProfile,
  consignorAddressTypes: masterData.consignorAddressTypes,
  incoterms: getMasterIncoterms(masterData.rfq.incoterms),
});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const EditConsignorForm = InjectSheet(styles)(Form.create()(EditConsignorOrgModal));
export default connect(mapStateToProps, mapDispatchToProps)(EditConsignorForm);
